import React, { useEffect, useRef, useState } from 'react'
import { LuGraduationCap, LuTriangleAlert, LuX } from 'react-icons/lu';
import nameIcon from "../../images/forms/name.svg";
import emailIcon from "../../images/forms/email.svg";
import phoneIcon from "../../images/forms/phone.svg";
import { PhoneInput } from 'react-international-phone';
import { PhoneNumberUtil } from 'google-libphonenumber';
import LoadLottie from '../loadLottie';
import Tick from "../../../json/tick-mark.json";
import axios from 'axios';
import { toast } from 'react-toastify';
import collegeIcon from "../../images/forms/college.svg";
import API from '../../../utils/API';

export default function SurgeStuFreeWebinar() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");
    const [collegeName, setCollegeName] = useState("");

    const [nameError, setNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [numberError, setNumberError] = useState("");

    const [countryCode, setCountryCode] = useState({});

    const [isClicked, setIsClicked] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const [timeLeft, setTimeLeft] = useState(30);
    const timerRef = useRef(null);

    const invalidCharsRegex = /^[\s\u200B-\u200D\uFEFF]+$/;

    const handleStep1 = async () => {
        try {
            const phoneUtil = PhoneNumberUtil.getInstance();
            const phoneWithoutPlus = number.startsWith(`+${countryCode?.dialCode}`)
                ? number.slice(countryCode?.dialCode?.length + 1)
                : number;

            // --- Regex Helpers ---
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$/i;

            // --- Name Validation ---
            if (!name.trim()) return setNameError("Please fill in this");
            if (invalidCharsRegex.test(name)) return setNameError("Invalid special characters");

            // --- Email Validation ---
            if (!email) return setEmailError("Please fill in this");
            if (invalidCharsRegex.test(email)) return setEmailError("Invalid special characters");
            if (!emailRegex.test(email)) return setEmailError("Hmm... that email doesn't look right");

            // --- Phone Validation ---
            let isValid = false;
            try {
                const parsedPhone = phoneUtil.parse(number, countryCode?.iso2);
                isValid = phoneUtil.isValidNumber(parsedPhone);
            } catch {
                isValid = false;
            }
            if (!isValid || !phoneWithoutPlus) {
                return setNumberError("Hmm... that number doesn't look right");
            }

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post("https://backend.hifrds.com/pepul/webinarRegistration/register.php", {
                email,
                name,
                phone: number,
                collegeName
            });
            if (data?.statusCode === 200) {
                setIsSuccess(true)
            }
            const createTask = await axios.post(API.TASK_BASE_URL + API.CREATE_TASK,
                {
                    projectId: 10084,
                    title: name,
                    description: JSON.stringify({
                        name: name,
                        email: email,
                        number: number,
                        collegeName: collegeName,
                    }, null, 2),
                    createdUser: 85155329,
                    assignee: [],
                    stage: "Open",
                    status: "Open",
                    tag: "Open"
                },
                {
                    headers: {
                        form: "bookdemo",
                    },
                });
            console.log(createTask);
            setIsSuccess(true)
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    useEffect(() => {
        if (isSuccess) {
            // reset timer every time popup opens
            setTimeLeft(30);

            timerRef.current = setInterval(() => {
                setTimeLeft((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        window.location.href = "/"
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);

    return (
        <div className='p-[20px] md:p-[50px] h-screen flex flex-col gap-[30px] md:gap-[60px] overflow-y-scroll scrollbar-hide'>
            <div>
                <div className='flex justify-between gap-[14px]'>
                    <div>
                        <h1 className='text-[#080808] font-semibold text-[20px] md:text-[28px]'>Surge Students Free Webinar</h1>
                        <h2 className='mt-[7px] text-[16px] md:text-[22px] font-normal'>Fill out the form below to reserve your spot.</h2>
                    </div>
                    <LuX className='text-[20px] md:text-[24px] mt-[5px]' onClick={() => { window.location.href = "/" }} />
                </div>
            </div>
            <div className="flex justify-start items-center w-full">
                <div className="flex flex-col md:grid lg:grid-cols-2 gap-[30px] lg:gap-[60px] w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500">
                    <div>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF3B3033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={nameIcon} alt='nameIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Full Name <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={name} placeholder='Enter your full name' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setName(e.target.value); setNameError('') }} />
                        </div>
                        {nameError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{nameError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF950033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={emailIcon} alt='emailIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Email ID <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='email' value={email} placeholder='Enter your Email ID' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setEmail(e.target.value); setEmailError('') }} />
                        </div>
                        {emailError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{emailError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FFCC0026] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={phoneIcon} alt='phoneIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Phone No ( WhatsApp enabled) <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[10px] md:rounded-[16px] px-[6px] md:px-[11px] py-[8px]'>
                            <PhoneInput defaultCountry="in" value={number} onChange={(phone, country) => { setNumber(phone); setNumberError(''); setCountryCode(country?.country); }}
                                countrySelector={{
                                    showSearch: true,
                                    searchPlaceholder: "Search country...",
                                }}
                                className="max-h-[40px] sm:max-h-[60px] h-full w-full focus:outline-none cursor-pointer surge-form placeholder:text-[#000]" />
                        </div>
                        {numberError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{numberError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#30B0C733] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={collegeIcon} alt='collegeIcon' className='w-[10px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>College Name <span className='text-[#797979]'>(Optional) </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={collegeName} placeholder='Enter college name' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setCollegeName(e.target.value); }} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex gap-[10px] md:gap-[20px] items-center justify-center flex-wrap'>
                <button disabled={isClicked} className='w-full md:w-[390px] h-[40px] md:h-[70px] rounded-[12px] md:rounded-[18px] bg-[#34C759] text-[#FFFFFF] font-semibold text-[20px] md:text-[25px]'
                    onClick={() => {
                        handleStep1();
                    }}>Submit</button>
            </div>
            <div>
                <div className='text-center'>
                    <h3 className='text-[#080808] font-semibold text-[20px] md:text-[28px]'>Our Students</h3>
                    <h3 className='mt-[7px] text-[16px] md:text-[22px] font-normal'>Students from top colleges are learning with us.</h3>
                </div>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[20px] mt-[20px] md:mt-[40px]'>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#F43F3533] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#F43F35] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>SRM University</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#FA971133] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#FA9711] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Vels University</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[90px] md:h-[140px]'>
                        <div className='bg-[#FECC1533] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#FECC15] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Sri Manakula Vinayagar Engineering College</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[90px] md:h-[140px]'>
                        <div className='bg-[#61B2D033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#61B2D0] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Er. Perumal manimekalai college of engineering</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#43C36033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#43C360] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Karpaga Vinayaga college of engineering</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#F1809233] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#F18092] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Mahendra Institute of Technology</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[90px] md:h-[140px]'>
                        <div className='bg-[#15127D33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#15127D] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] md:mt-[3px]'>Saraswathy college of engineering and technology</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#34343433] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#343434] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>IIT Madras</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#8F8F8F33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#8F8F8F] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Sathyabama University</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#FA5F1133] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#FA5F11] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Anna University</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#FEF21533] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#FEF215] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Takshashila University</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#61D0BC33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#61D0BC] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Chennai Institute of Technology</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#F16A6433] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#F16A64] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Velammal Engineering College</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#50B4CA33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#50B4CA] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Panimalar Engineering College</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#66CE8133] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#66CE81] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Easwari Engineering College</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#9C37DC33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#9C37DC] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>RMK Engineering College</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#66BACC33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#66BACC] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Sairam Engineering College</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#00037133] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#000371] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Saveetha Engineering College</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#F5C82C33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#F5C82C] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Rajalakshmi Engineering College</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                    <div className='w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[12px] p-[10px] flex gap-[8px] h-[80px] md:h-[140px]'>
                        <div className='bg-[#EC859933] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#EC8599] text-[14px] md:text-[20px] font-bold'>
                            <LuGraduationCap />
                        </div>
                        <div className='flex justify-between flex-col'>
                            <p className='text-[#080808] font-semibold text-[14px] md:text-[20px] mt-[3px]'>Loyola Institute of Technology</p>
                            <p className='font-normal text-[12px] md:text-[20px] opacity-70'><span className='font-semibold'>20+</span> Students enrolled</p>
                        </div>
                    </div>
                </div>
            </div>
            {isSuccess && (
                <div className="bg-[#000]/[70%] fixed inset-0 z-[100] h-screen w-full flex justify-center items-center">
                    <div className='bg-[#FFF] w-11/12 md:w-1/2 max-h-[80vh] rounded-[14px] p-[20px] relative text-center'>
                        <LuX className='text-[16px] md:text-[22px] cursor-pointer absolute top-[20px] right-[20px]'
                            onClick={() => {
                                window.location.href = "/"
                            }} />
                        <div className='font-medium text-[16px] md:text-[22px]'>
                            <p className='text-[#414141] text-center'>Automatically closing in</p>
                            <div className='size-[40px] md:size-[50px] mx-auto mt-[4px] md:mt-[7px] rounded-full border-[2px] border-[#34C759] flex justify-center items-center text-[#34C759]'>{timeLeft}</div>
                        </div>
                        <div className='mt-[12px] md:mt-[24px]'>
                            <div className='size-[80px] md:size-[120px] mx-auto flex justify-center items-center'>
                                <LoadLottie animationData={Tick} loop={true} />
                            </div>
                            <p className='text-[20px] md:text-[25px] mt-[4px] font-semibold text-[#000000]'>Congratulations your slot is booked successfully</p>
                            <p className='text-[16px] md:text-[22px] mt-[4px] font-medium text-[#828487]'>We sent the details in registered email.</p>
                        </div>
                        <button className="mt-[12px] md:mt-[24px] w-full h-[45px] md:h-[72px] rounded-[12px] md:rounded-[18px] text-[16px] md:text-[25px] font-semibold bg-[#34C759] text-[#F3F3F3]"
                            onClick={() => {
                                window.location.href = "/"
                            }}>Back to Home</button>
                    </div>
                </div>
            )}
        </div>
    )
}
